import type {
  ActionType,
  ResponseAcademicRisk,
  RiskType,
} from '@/domains/academicRisk';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type {
  AcademicRiskStoreEntity,
  AcademicRiskStoreRepository,
} from '../models';

const defaultAcademicRiskState: AcademicRiskStoreEntity = {
  apiData: null,
  searchQuery: '',
  activeFilter: '',
  isLoading: false,
  actionTypes: [],
  massiveActionTypes: [],
  riskTypes: [],
  catalogsLoaded: false,
};

export const useAcademicRiskStore = create<AcademicRiskStoreRepository>()(
  persist(
    (set, get) => ({
      ...defaultAcademicRiskState,

      loadData: (apiResponse: ResponseAcademicRisk) => {
        const { apiData } = get();
        if (JSON.stringify(apiData) === JSON.stringify(apiResponse)) return;

        set({
          apiData: apiResponse,
          isLoading: false,
        });
      },

      setSearchQuery: (query: string) => {
        set({ searchQuery: query });
      },

      setFilter: (filter: string) => {
        set({ activeFilter: filter });
      },

      setLoading: (loading: boolean) => set({ isLoading: loading }),

      loadActionTypes: (types: ActionType[]) => {
        set({ actionTypes: types });
      },

      loadMassiveActionTypes: (types: ActionType[]) => {
        set({ massiveActionTypes: types });
      },

      loadRiskTypes: (types: RiskType[]) => {
        set({ riskTypes: types });
      },

      setCatalogsLoaded: (loaded: boolean) => {
        set({ catalogsLoaded: loaded });
      },

      clearAcademicRisk: () => set({ ...defaultAcademicRiskState }),
    }),
    {
      name: '@app/academic-risk',
      partialize: (state: AcademicRiskStoreRepository) => ({
        searchQuery: state.searchQuery,
        activeFilter: state.activeFilter,
      }),
    },
  ),
);
